export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9909.ff979179.jpg";